import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import { auth } from "./firebase";
import { com } from "./assets/keymanweb16/keymanweb.js";
import "./aksarabali_panlex-1.1.1.js";
import { onAuthStateChanged } from "firebase/auth";
import "./assets/css/tailwind.css";
import "./assets/notoSans/stylesheet.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from "@fortawesome/vue-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { faUserInjured } from "@fortawesome/free-solid-svg-icons";
import { faMedal } from "@fortawesome/free-solid-svg-icons";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { faNewspaper } from "@fortawesome/free-solid-svg-icons";
import { faImage } from "@fortawesome/free-solid-svg-icons";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { faComment as fasComment } from "@fortawesome/free-solid-svg-icons";
import { faCircleUp } from "@fortawesome/free-regular-svg-icons";
import { faComment as farComment } from "@fortawesome/free-regular-svg-icons";
import { faHeart as farHeart } from "@fortawesome/free-regular-svg-icons";
import { faHeart as fasHeart } from "@fortawesome/free-solid-svg-icons";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { faAward } from "@fortawesome/free-solid-svg-icons";
library.add(
  faHome,
  faUserInjured,
  faMedal,
  faUserCircle,
  faBell,
  faBars,
  faCircleUp,
  faPencil,
  faTrash,
  faSearch,
  faChevronLeft,
  faChevronRight,
  faTimes,
  faUsers,
  faUser,
  faQuestionCircle,
  faExclamationCircle,
  faSpinner,
  faPaperPlane,
  faNewspaper,
  faImage,
  faCheckCircle,
  faChevronDown,
  fasComment,
  farComment,
  farHeart,
  fasHeart,
  faEyeSlash,
  faEye,
  faAward
);
(function (kmw) {
  kmw.init({ attachType: "auto" });
  kmw.addKeyboards({
    id: "aksarabali_panlex", // The keyboard's unique identification code.
    name: "Bali", // The keyboard's user-readable name.
    languages: {
      id: "ban-bali", // A BCP 47 code uniquely identifying the language.
      name: "Bali", // The language's name.
      font: {
        family: "Noto Sans Balinese",
        //  source:['@/assets/vimala/fonts/Vimala.ttf','@/assets/vimala/fonts/Vimala.woff'],
      },
    },
    filename: "@/aksarabali_panlex-1.1.1.js", // A valid path to the compiled *.js file representing the keyboard.
  });
  //   kmw.addKeyboards('@ban-bali');
})(keyman);
let app;
onAuthStateChanged(auth, async (user) => {
  if (!app) {
    app = createApp(App)
      .use(store)
      .use(router)
      .component("font-awesome-icon", FontAwesomeIcon)
      .component("font-awesome-layers", FontAwesomeLayers)
      .component("font-awesome-layer-text", FontAwesomeLayersText)
      .mount("#app");
  }

  if (user) {
    store.state.loading = true;
    await store.dispatch("fetchUserProfile", user);
    await store.dispatch("fetchAllPosts");
    await store.dispatch("fetchAllNotifs");
    await store.dispatch("fetchSplashNotifs");
    localStorage.setItem("user", user.uid);
    store.state.loading = false;
  } else {
    localStorage.removeItem("user");
  }
});
